import { useState } from 'react'

export default function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading,  setLoading]  = useState(false)
  const [error,    setError]    = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const res  = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      })
      const data = await res.json()
      if (data.token) {
        onLogin(data.token)
      } else {
        setError(data.error || 'Invalid credentials')
      }
    } catch {
      setError('Could not connect to server')
    } finally {
      setLoading(false)
    }
  }

  const canSubmit = username && password && !loading

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0a0d14', position: 'relative', overflow: 'hidden',
    }}>
      <div style={{ position:'absolute', top:'20%', left:'50%', transform:'translateX(-50%)',
        width:500, height:300, background:'radial-gradient(ellipse, rgba(0,100,210,0.08) 0%, transparent 65%)',
        pointerEvents:'none' }}/>

      <div style={{
        width: '100%', maxWidth: 400,
        background: '#111827', border: '1px solid #1f2937',
        borderRadius: 20, overflow: 'hidden',
        boxShadow: '0 8px 48px rgba(0,0,0,0.6)',
      }}>
        <div style={{ height: 3, background: 'linear-gradient(90deg, #0064d2, #f5a623)' }}/>

        <div style={{ padding: '40px 36px 36px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 32 }}>
            <div style={{
              width: 38, height: 38, borderRadius: 10,
              background: 'linear-gradient(135deg, #79c142, #0064d2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 12, fontWeight: 800, color: '#fff',
            }}>S↔E</div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#f1f5f9' }}>SyncE Bridge</div>
              <div style={{ fontSize: 10, color: '#0064d2', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase' }}>Admin Panel</div>
            </div>
          </div>

          <div style={{ fontSize: 22, fontWeight: 800, color: '#f1f5f9', marginBottom: 6, letterSpacing: '-.5px' }}>
            Sign in
          </div>
          <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 28 }}>
            Enter your admin credentials to continue
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#9ca3af', display: 'block', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '.06em' }}>
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="Enter username"
                autoFocus
                autoComplete="username"
                style={{
                  width: '100%', padding: '12px 14px', boxSizing: 'border-box',
                  background: '#1f2937', border: '1px solid #374151',
                  borderRadius: 10, color: '#f1f5f9', fontSize: 14, outline: 'none',
                  transition: 'border-color .15s',
                }}
                onFocus={e => e.target.style.borderColor = '#0064d2'}
                onBlur={e => e.target.style.borderColor = '#374151'}
              />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#9ca3af', display: 'block', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '.06em' }}>
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                autoComplete="current-password"
                style={{
                  width: '100%', padding: '12px 14px', boxSizing: 'border-box',
                  background: '#1f2937', border: `1px solid ${error ? '#ef4444' : '#374151'}`,
                  borderRadius: 10, color: '#f1f5f9', fontSize: 14, outline: 'none',
                  transition: 'border-color .15s',
                }}
                onFocus={e => e.target.style.borderColor = '#0064d2'}
                onBlur={e => e.target.style.borderColor = error ? '#ef4444' : '#374151'}
              />
              {error && <div style={{ fontSize: 12, color: '#ef4444', marginTop: 6 }}>{error}</div>}
            </div>

            <button type="submit" disabled={!canSubmit} style={{
              width: '100%', padding: '13px',
              background: !canSubmit ? '#374151' : 'linear-gradient(135deg, #0064d2, #e53238)',
              border: 'none', borderRadius: 10,
              color: '#fff', fontSize: 14, fontWeight: 700, cursor: !canSubmit ? 'not-allowed' : 'pointer',
              transition: 'opacity .15s',
            }}>
              {loading ? 'Signing in...' : 'Sign in to Admin Panel'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
